module.exports = __webpack_public_path__ + "img/debenture.4ae7bb62.svg";